import React, {Component} from 'react'

import Photo from '../images/certification.png'
import Mobilephoto from '../images/mobilecertification.png'

const Jeyu = {
  certification: {
   height: '16vh',
   backgroundImage: 'url('+Photo+')',
   backgroundRepeat: 'no-repeat',
   backgroundSize: 'contain',
   backgroundPosition: 'left center'
  },
  mobilecertification: {
   backgroundImage: 'url('+Mobilephoto+')',
   backgroundRepeat: 'no-repeat',
   backgroundSize: 'contain',
   backgroundPosition: 'center center',
   height: '500px'
 },
 bg: {
   background: '#fff'
 }
}

export default class Banner extends Component {
  render() {
    return(
     <div className="container-fluid">
      <div className="row" style={Jeyu.bg}>
      <div className="container">
       <div className="row">
        <div className="certification" style={Jeyu.certification}></div>
        <div className="mobilecertification" style={Jeyu.mobilecertification}></div>
       </div>
      </div>
      </div>
     </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Component/BannerBottomInfo.js